package com.essntl.features.client.domain.repository

import com.essntl.features.client.domain.model.ClientModel

interface ClientRepository {
    suspend fun getAll(): Result<List<ClientModel>>

    suspend fun getAll(
        page: Long,
        limit: Int = 10,
        query: String,
    ): Result<List<ClientModel>>

    suspend fun getById(id: String): Result<ClientModel>

    suspend fun getByIds(ids: List<String>): Result<List<ClientModel>>

    suspend fun insert(client: ClientModel): Result<ClientModel>

    suspend fun update(client: ClientModel): Result<ClientModel>

    suspend fun delete(id: String): Result<Unit>

    suspend fun getByPhoneNumbers(phoneNumbers: Set<String>): Result<List<ClientModel>>
}
